export default __webpack_public_path__ + "static/media/cupcake-1.3487e859.jpg";